import React, { useMemo } from "react";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { useClinicsQuery } from "../../../../../api/queries/useClinicsQuery";
import { uiNotification } from "../../../../../services/UINotificationService";
import { Select } from "../../../../../shared/Select/Select";

export function ClinicsSelect({ value, onSelect }) {
  const { tCommon } = useAppTranslation.Common();
  const [selected, setSelected] = React.useState(value);

  const { data, isLoading, isFetching } = useClinicsQuery({
    onError: () => {
      uiNotification.error(tCommon("error.fetchClinics"));
    },
  });

  const options = useMemo(() => {
    const optionsArray =
      data?.map((clinic) => ({
        label: clinic.name,
        value: clinic.id,
      })) || [];

    return [{ label: "All Clinics", value: 0 }, ...optionsArray];
  }, [data]);

  return (
    <Select
      isSearchable
      isLoading={isLoading || isFetching}
      size="small"
      options={options}
      value={options.find((option) => option.value === selected) || null}
      onChange={(option) => {
        onSelect(option.value);
        setSelected(option.value);
      }}
    />
  );
}
